import { createSlice, createAsyncThunk } from "@reduxjs/toolkit"
import axios from "axios"
import { SessionManager, showAccessDeniedAlert, showTokenExpiredAlert, getConfig } from "utils"

export const fileList = createAsyncThunk('documentFile/list', async ({ pageable, navigate }) => {
    try {
        const res = await axios({
            method: 'GET',
            url: getConfig.API_URL + 'document_file',
            params: {
                pageSize: pageable?.pageSize,
                pageNo: pageable?.currentPage,
                search: pageable?.search,
                document_folder_id: pageable?.document_folder_id,
            },
            headers: { "Content-Type": "application/json", "Authorization": SessionManager.getCookie("user_token") }
        })
        return res
    } catch (error) {
        return error.response
    }
})

export const fileDetails = createAsyncThunk('documentFile/details', async ({ id, navigate }) => {
    try {
        const res = await axios({
            method: 'GET',
            url: getConfig.API_URL + `document_file/${id}`,
            headers: { "Content-Type": "application/json", "Authorization": SessionManager.getCookie("user_token") }
        })
        return res
    } catch (error) {
        return error.response
    }
})

export const addFile = createAsyncThunk('documentFile/add', async (data) => {

    const bodyFormData = new FormData()

    bodyFormData.append('premise_id', data?.values?.premise_id ?? '')
    bodyFormData.append('document_folder_id', data?.values?.document_folder_id ?? '')
    bodyFormData.append('file_name', data?.values?.file_name ?? '')
    bodyFormData.append('description', data?.values?.description ?? '')

    if (data?.values?.document_file) {
        bodyFormData.append('document_file', data.values.document_file)
    }

    try {
        const res = await axios({
            method: 'POST',
            url: getConfig.API_URL + 'document_file',
            data: bodyFormData,
            headers: { "Content-Type": "multipart/form-data", type: 'document_file', "Authorization": SessionManager.getCookie('user_token') }
        })
        return res
    } catch (error) {
        return error.response
    }
})

export const updateFile = createAsyncThunk('documentFile/update', async (data) => {

    const bodyFormData = new FormData()

    bodyFormData.append('document_file_id', data?.values?.id)
    bodyFormData.append('premise_id', data?.values?.premise_id ?? '')
    bodyFormData.append('document_folder_id', data?.values?.document_folder_id ?? '')
    bodyFormData.append('file_name', data?.values?.file_name ?? '')
    bodyFormData.append('description', data?.values?.description ?? '')

    if (data?.values?.document_file) {
        bodyFormData.append('document_file', data.values.document_file)
    }

    try {
        const res = await axios({
            method: 'POST',
            url: getConfig.API_URL + 'update_document_file',
            data: bodyFormData,
            headers: { "Content-Type": "multipart/form-data", type: 'document_file', "Authorization": SessionManager.getCookie('user_token') }
        })
        return res
    } catch (error) {
        return error.response
    }
})

export const delFile = createAsyncThunk('documentFile/delete', async (data) => {
    try {
        const res = await axios({
            method: 'DELETE',
            url: getConfig.API_URL + `document_file/${data?.id}`,
            headers: { "Content-Type": "application/json", "Authorization": SessionManager.getCookie('user_token') }
        })
        return res
    } catch (error) {
        return error.response
    }
})

const documentFile = createSlice({
    name: 'documentFile',
    initialState: {
        list: [],
        details: null,
        loading: false,
    },
    extraReducers: (builder) => {
        builder.addCase(fileList.fulfilled, (state, action) => {
            state.loading = false
            if (action?.payload?.status === 200) {
                state.list = action.payload.data.data
            } else if (action?.payload?.status === 401) {
                showTokenExpiredAlert(action?.payload?.data?.message, action.meta.arg.navigate)
                state.list = []
            } else if (action?.payload?.status === 403) {
                showAccessDeniedAlert(action.meta.arg.navigate)
                state.list = []
            } else {
                state.list = []
            }
        })

        builder.addCase(fileDetails.fulfilled, (state, action) => {
            if (action?.payload?.status === 200) {
                state.details = action.payload.data.data
            } else if (action?.payload?.status === 401) {
                showTokenExpiredAlert(action?.payload?.data?.message, action.meta.arg.navigate)
                state.details = null
            } else if (action?.payload?.status === 403) {
                showAccessDeniedAlert(action.meta.arg.navigate)
                state.details = null
            } else {
                state.details = null
            }
        })
    }
})

export default documentFile.reducer;